<div>

  <div [id]="props['idexpand']" [title]="props.label">

    <div class="sp2"></div>
    <ng-container *ngIf="props['onFormCreation']">

      <div *ngIf="props['hideHeader'] == null || props['hideHeader'] == false" class="row22">
        <div class="d-felx flex-column colmax2" style="width: 100%;">

          <div (click)="onExpand()" class="section_bar" style="min-height: 36px;">
            <div class="valign-center mat-body-2" style="width: 100%;">{{ props.label }}</div>
            <span class="icons-spacer"></span>
            <button mat-button type="button" class="btn btn-default">
              <mat-icon *ngIf="options?.formState[this.props['idexpand']] == true">expand_more</mat-icon>
              <mat-icon *ngIf="options?.formState[this.props['idexpand']] == false">expand_less</mat-icon>
            </button>

          </div>


        </div>

      </div>
    </ng-container>

    <div class="row2">
      <div class="colmax">

        <div *ngIf="options?.formState[this.props['idexpand']] == true">
          <div class="sp"></div>
          <ng-container #fieldComponent></ng-container>
        </div>
      </div>
    </div>
    <div class="sp2"></div>
  </div>
</div>